import {
  GET_AIRLINES_DETAILS_REQUEST,
  GET_AIRLINES_DETAILS_SUCCESS,
  GET_AIRLINES_DETAILS_FAIL,
  GET_AIRLINES_DETAILS_RESET,
  CREATE_HX_RULES_REQUEST,
  CREATE_HX_RULES_SUCCESS,
  CREATE_HX_RULES_RESET,
  CREATE_HX_RULES_FAIL,
  CREATE_AGENCY_BOOKING_REPORT_RULES_REQUEST,
  CREATE_AGENCY_BOOKING_REPORT_RULES_SUCCESS,
  CREATE_AGENCY_BOOKING_REPORT_RULES_RESET,
  CREATE_AGENCY_BOOKING_REPORT_RULES_FAIL,
  CREATE_SC_RULES_REQUEST,
  CREATE_SC_RULES_SUCCESS,
  CREATE_SC_RULES_RESET,
  CREATE_SC_RULES_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  SEND_OTP_REQUECT,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAIL,
  GET_AL_HX_RULES_REQUEST,
  GET_ALL_HX_RULES_SUCCESS,
  GET_ALL_HX_RULES_FAIL,
  GET_ALL_HX_RULES_RESET,
  GET_AL_AGENCY_BOOKING_REPORT_RULES_REQUEST,
  GET_ALL_AGENCY_BOOKING_REPORT_RULES_SUCCESS,
  GET_ALL_AGENCY_BOOKING_REPORT_RULES_FAIL,
  GET_ALL_AGENCY_BOOKING_REPORT_RULES_RESET,
  GET_AL_SC_RULES_REQUEST,
  GET_ALL_SC_RULES_SUCCESS,
  GET_ALL_SC_RULES_FAIL,
  GET_ALL_SC_RULES_RESET,
  GET_QUEUELIST_REQUEST,
  GET_QUEUELIST_SUCCESS,
  GET_QUEUELIST_FAIL,
  GET_QUEUELIST_RESET,
  GET_SERVER_LOGS_FAIL,
  GET_SERVER_LOGS_REQUEST,
  GET_SERVER_LOGS_RESET,
  GET_SERVER_LOGS_SUCCESS,
  USER_LOGOUT,
  GET_HX_RULE_FAIL,
  GET_HX_RULE_REQUEST,
  GET_HX_RULE_SUCCESS,
  GET_HX_RULE_RESET,
  GET_AGENCY_BOOKING_REPORT_RULE_FAIL,
  GET_AGENCY_BOOKING_REPORT_RULE_REQUEST,
  GET_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
  GET_AGENCY_BOOKING_REPORT_RULE_RESET,
  GET_SC_RULE_FAIL,
  GET_SC_RULE_REQUEST,
  GET_SC_RULE_SUCCESS,
  GET_SC_RULE_RESET,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAIL,
  GET_CUSTOMER_RESET,
  GET_ALL_CUSTOMERS_REQUEST,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_ALL_CUSTOMERS_FAIL,
  GET_ALL_CUSTOMERS_RESET,
  CREATE_CUSTOMER_REQUEST,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAIL,
  CREATE_CUSTOMER_RESET,
  UPDATE_HX_RULE_REQUEST,
  UPDATE_HX_RULE_SUCCESS,
  UPDATE_HX_RULE_FAIL,
  UPDATE_HX_RULE_RESET,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_REQUEST,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_FAIL,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_RESET,
  UPDATE_SC_RULE_SUCCESS,
  UPDATE_SC_RULE_REQUEST,
  UPDATE_SC_RULE_FAIL,
  UPDATE_SC_RULE_RESET,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  UPDATE_CUSTOMER_RESET,
  DELETE_HX_RULE_REQUEST,
  DELETE_HX_RULE_SUCCESS,
  DELETE_HX_RULE_FAIL,
  DELETE_HX_RULE_RESET,
  DELETE_AGENCY_BOOKING_REPORT_RULE_REQUEST,
  DELETE_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
  DELETE_AGENCY_BOOKING_REPORT_RULE_FAIL,
  DELETE_AGENCY_BOOKING_REPORT_RULE_RESET,
  DELETE_SC_RULE_REQUEST,
  DELETE_SC_RULE_SUCCESS,
  DELETE_SC_RULE_FAIL,
  DELETE_SC_RULE_RESET,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  DELETE_CUSTOMER_RESET,
  GET_ALL_COUNTRY_REQUEST,
  GET_ALL_COUNTRY_SUCCESS,
  GET_ALL_COUNTRY_FAIL,
  GET_ALL_COUNTRY_RESET,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  GET_USER_RESET,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  UPDATE_USER_RESET,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  RESET_PASSWORD_RESET,
  SEND_OTP_RESET,
  USER_LOGIN_RESET,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CHANGE_PASSWORD_RESET,
  GET_MANAGE_BOOKING_DATA_REQUEST,
  GET_MANAGE_BOOKING_DATA_SUCCESS,
  GET_MANAGE_BOOKING_DATA_FAIL,
  GET_MANAGE_BOOKING_DATA_RESET,
  PRINT_ITINERARY_DATA_REQUEST,
  PRINT_ITINERARY_DATA_SUCCESS,
  PRINT_ITINERARY_DATA_FAIL,
  PRINT_ITINERARY_DATA_RESET,
  EMAIL_ITINERARY_DATA_REQUEST,
  EMAIL_ITINERARY_DATA_SUCCESS,
  EMAIL_ITINERARY_DATA_FAIL,
  EMAIL_ITINERARY_DATA_RESET,
  GET_ALL_USERS_REQUEST,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAIL,
  GET_ALL_USERS_RESET,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  DELETE_USER_RESET,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  CREATE_USER_RESET,
  GET_LOGGED_IN_USER_REQUEST,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_LOGGED_IN_USER_FAIL,
  GET_LOGGED_IN_USER_RESET,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  GET_PRODUCTS_RESET,
  GET_USER_PERMISSION_REQUEST,
  GET_USER_PERMISSION_SUCCESS,
  GET_USER_PERMISSION_FAIL,
  GET_USER_PERMISSION_RESET,
  CHECK_PCC_REQUEST,
  CHECK_PCC_SUCCESS,
  CHECK_PCC_FAIL,
  CHECK_PCC_RESET,
  GET_ALL_ACTIVE_CUSTOMERS_REQUEST,
  GET_ALL_ACTIVE_CUSTOMERS_SUCCESS,
  GET_ALL_ACTIVE_CUSTOMERS_FAIL,
  GET_ALL_ACTIVE_CUSTOMERS_RESET,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_REQUEST,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_SUCCESS,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_FAIL,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_RESET,
  GET_TP_BATCH_REPORT_REQUEST,
  GET_TP_BATCH_REPORT_SUCCESS,
  GET_TP_BATCH_REPORT_FAIL,
  GET_TP_BATCH_REPORT_RESET,
  EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST,
  EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS,
  EMAIL_MULTI_PCC_TICKET_REPORT_FAIL,
  EMAIL_MULTI_PCC_TICKET_REPORT_RESET,
  GET_TICKET_REPORT_REQUEST,
  GET_TICKET_REPORT_SUCCESS,
  GET_TICKET_REPORT_FAIL,
  GET_TICKET_REPORT_RESET,
  GET_CURRENCY_REQUEST,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_FAIL,
  GET_CURRENCY_RESET,
  DOWNLOAD_EXCEL_REQUEST,
  DOWNLOAD_EXCEL_SUCCESS,
  DOWNLOAD_EXCEL_FAIL,
  DOWNLOAD_EXCEL_RESET,
  DOWNLOAD_CSV_REQUEST,
  DOWNLOAD_CSV_SUCCESS,
  DOWNLOAD_CSV_FAIL,
  DOWNLOAD_CSV_RESET,
  GET_CUSTOMER_STATIC_DATA_REQUEST,
  GET_CUSTOMER_STATIC_DATA_SUCCESS,
  GET_CUSTOMER_STATIC_DATA_FAIL,
  GET_CUSTOMER_STATIC_DATA_RESET,
  CREATE_CUSTOMER_LOGIN_REQUEST,
  CREATE_CUSTOMER_LOGIN_SUCCESS,
  CREATE_CUSTOMER_LOGIN_FAIL,
  CREATE_CUSTOMER_LOGIN_RESET,
  GET_ALL_CUSTOMERS_LOGINS_REQUEST,
  GET_ALL_CUSTOMERS_LOGINS_SUCCESS,
  GET_ALL_CUSTOMERS_LOGINS_FAIL,
  GET_ALL_CUSTOMERS_LOGINS_RESET,
  UPDATE_CUSTOMER_LOGINS_REQUEST,
  UPDATE_CUSTOMER_LOGINS_SUCCESS,
  UPDATE_CUSTOMER_LOGINS_FAIL,
  UPDATE_CUSTOMER_LOGINS_RESET,
  GET_ALL_PARENT_CUSTOMERS_REQUEST,
  GET_ALL_PARENT_CUSTOMERS_SUCCESS,
  GET_ALL_PARENT_CUSTOMERS_FAIL,
  GET_ALL_PARENT_CUSTOMERS_RESET,
  REMOVE_CUSTOMER_LOGO_REQUEST,
  REMOVE_CUSTOMER_LOGO_SUCCESS,
  REMOVE_CUSTOMER_LOGO_FAIL,
  REMOVE_CUSTOMER_LOGO_RESET,
  DOWNLOAD_INVOICE_REQUEST,
  DOWNLOAD_INVOICE_SUCCESS,
  DOWNLOAD_INVOICE_FAIL,
  DOWNLOAD_INVOICE_RESET,
} from "../../Constants/Constants";

export const HXCancellationGetAirlineDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_AIRLINES_DETAILS_REQUEST:
      return {
        loading: true,
      };
    case GET_AIRLINES_DETAILS_SUCCESS:
      return {
        loading: false,
        airlineInfo: action.payload,
      };
    case GET_AIRLINES_DETAILS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_AIRLINES_DETAILS_RESET:
      return {
        airlineInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

const initialState = {
  logsInfo: [],   // 👈 must exist so your selector isn’t undefined
  loading: false,
  error: null,
};

export const GetLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SERVER_LOGS_REQUEST:
      return { ...state, loading: true, error: null };

    case GET_SERVER_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        logsInfo: action.payload, // 👈 put API array directly here
      };

    case GET_SERVER_LOGS_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export const HXCancellationCreateHXRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_HX_RULES_REQUEST:
      return {
        loading: true,
      };
    case CREATE_HX_RULES_SUCCESS:
      return {
        loading: false,
        hxRuleInfo: action.payload,
      };
    case CREATE_HX_RULES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_HX_RULES_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const AgencyBookingReportCreateRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_AGENCY_BOOKING_REPORT_RULES_REQUEST:
      return {
        loading: true,
      };
    case CREATE_AGENCY_BOOKING_REPORT_RULES_SUCCESS:
      return {
        loading: false,
        agencyBookingReportRuleInfo: action.payload,
      };
    case CREATE_AGENCY_BOOKING_REPORT_RULES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_AGENCY_BOOKING_REPORT_RULES_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const ScheudleChangeCreateSCRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_SC_RULES_REQUEST:
      return {
        loading: true,
      };
    case CREATE_SC_RULES_SUCCESS:
      return {
        loading: false,
        scRuleInfo: action.payload,
      };
    case CREATE_SC_RULES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_SC_RULES_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const CreateCustomerReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case CREATE_CUSTOMER_SUCCESS:
      return {
        loading: false,
        customerInfo: action.payload,
      };
    case CREATE_CUSTOMER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_CUSTOMER_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const UserLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return {
        loginloading: true,
      };
    case USER_LOGIN_SUCCESS:
      return {
        loading: false,
        token: action.payload,
      };
    case USER_LOGIN_FAIL:
      return {
        loading: false,
        loginerror: action.payload,
      };
    case USER_LOGIN_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const SendOTPReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_OTP_REQUECT:
      return {
        sendOTPloading: true,
      };
    case SEND_OTP_SUCCESS:
      return {
        sendOTPloading: false,
        sendOTPInfo: action.payload,
      };
    case SEND_OTP_FAIL:
      return {
        sendOTPloading: false,
        sendOTPerror: action.payload,
      };
    case SEND_OTP_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetHXRulesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_AL_HX_RULES_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_HX_RULES_SUCCESS:
      return {
        loading: false,
        HXRulesInfo: action.payload,
      };
    case GET_ALL_HX_RULES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_HX_RULES_RESET:
      return {
        HXRulesInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAgencyBookingReportRulesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_AL_AGENCY_BOOKING_REPORT_RULES_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_AGENCY_BOOKING_REPORT_RULES_SUCCESS:
      return {
        loading: false,
        agencyBookingReportRulesInfo: action.payload,
      };
    case GET_ALL_AGENCY_BOOKING_REPORT_RULES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_AGENCY_BOOKING_REPORT_RULES_RESET:
      return {
        agencyBookingReportRulesInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const GetSCRulesReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_AL_SC_RULES_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_SC_RULES_SUCCESS:
      return {
        loading: false,
        SCRulesInfo: action.payload,
      };
    case GET_ALL_SC_RULES_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_SC_RULES_RESET:
      return {
        SCRulesInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const GetQueueListByPCCReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_QUEUELIST_REQUEST:
      return {
        loading: true,
      };
    case GET_QUEUELIST_SUCCESS:
      return {
        loading: false,
        getQueueListByPCC: action.payload,
      };
    case GET_QUEUELIST_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_QUEUELIST_RESET:
      return {
        getQueueListByPCC: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCustomersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_CUSTOMERS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        loading: false,
        customersInfo: action.payload,
      };
    case GET_ALL_CUSTOMERS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_CUSTOMERS_RESET:
      return {
        customersInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAllActiveCustomersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_ACTIVE_CUSTOMERS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_ACTIVE_CUSTOMERS_SUCCESS:
      return {
        loading: false,
        activeCustomersInfo: action.payload,
      };
    case GET_ALL_ACTIVE_CUSTOMERS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_ACTIVE_CUSTOMERS_RESET:
      return {
        activeCustomersInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAllActiveReportEnabledCustomersReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_SUCCESS:
      return {
        loading: false,
        activeReportEnabledCustomersInfo: action.payload,
      };
    case GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_RESET:
      return {
        activeReportEnabledCustomersInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetHXRuleByIDReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_HX_RULE_REQUEST:
      return {
        loading: true,
      };
    case GET_HX_RULE_SUCCESS:
      return {
        loading: false,
        ruleInfo: action.payload,
      };
    case GET_HX_RULE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_HX_RULE_RESET:
      return {
        ruleInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAgencyBookingReportRuleByIDReducer = (
  state = {},
  action
) => {
  switch (action.type) {
    case GET_AGENCY_BOOKING_REPORT_RULE_REQUEST:
      return {
        loading: true,
      };
    case GET_AGENCY_BOOKING_REPORT_RULE_SUCCESS:
      return {
        loading: false,
        ruleInfo: action.payload,
      };
    case GET_AGENCY_BOOKING_REPORT_RULE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_AGENCY_BOOKING_REPORT_RULE_RESET:
      return {
        ruleInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const GetSCRuleByIDReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_SC_RULE_REQUEST:
      return {
        loading: true,
      };
    case GET_SC_RULE_SUCCESS:
      return {
        loading: false,
        ruleInfo: action.payload,
      };
    case GET_SC_RULE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_SC_RULE_RESET:
      return {
        ruleInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCustomerByIDReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_SUCCESS:
      return {
        loading: false,
        customerById: action.payload,
      };
    case GET_CUSTOMER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_RESET:
      return {
        customerById: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCustomerStaticDataByCustIDReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CUSTOMER_STATIC_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_CUSTOMER_STATIC_DATA_SUCCESS:
      return {
        loading: false,
        customerStaticDataInfo: action.payload,
      };
    case GET_CUSTOMER_STATIC_DATA_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CUSTOMER_STATIC_DATA_RESET:
      return {
        customerStaticDataInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const UpdateHXRuleReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_HX_RULE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_HX_RULE_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_HX_RULE_FAIL:
      return {
        laoding: false,
        updateerror: action.payload,
      };
    case UPDATE_HX_RULE_RESET:
      return {
        ...state,
        success: false,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const UpdateAgencyBookingReportRuleReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_AGENCY_BOOKING_REPORT_RULE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_AGENCY_BOOKING_REPORT_RULE_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_AGENCY_BOOKING_REPORT_RULE_FAIL:
      return {
        laoding: false,
        updateerror: action.payload,
      };
    case UPDATE_AGENCY_BOOKING_REPORT_RULE_RESET:
      return {
        ...state,
        success: false,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const UpdateSCRuleReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_SC_RULE_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_SC_RULE_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_SC_RULE_FAIL:
      return {
        laoding: false,
        updateerror: action.payload,
      };
    case UPDATE_SC_RULE_RESET:
      return {
        ...state,
        success: false,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};


export const UpdateCustomerReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_CUSTOMER_FAIL:
      return {
        laoding: false,
        updateerror: action.payload,
      };
    case UPDATE_CUSTOMER_RESET:
      return {
        ...state,
        success: false,
        message: null,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const DeleteHXRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_HX_RULE_REQUEST:
      return {
        loading: true,
      };
    case DELETE_HX_RULE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case DELETE_HX_RULE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case DELETE_HX_RULE_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const DeleteAgencyBookingReportRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_AGENCY_BOOKING_REPORT_RULE_REQUEST:
      return {
        loading: true,
      };
    case DELETE_AGENCY_BOOKING_REPORT_RULE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case DELETE_AGENCY_BOOKING_REPORT_RULE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case DELETE_AGENCY_BOOKING_REPORT_RULE_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const DeleteSCRuleReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_SC_RULE_REQUEST:
      return {
        loading: true,
      };
    case DELETE_SC_RULE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case DELETE_SC_RULE_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case DELETE_SC_RULE_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const DeleteCustomerReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_CUSTOMER_REQUEST:
      return {
        loading: true,
      };
    case DELETE_CUSTOMER_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case DELETE_CUSTOMER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case DELETE_CUSTOMER_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAllCountryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_COUNTRY_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_COUNTRY_SUCCESS:
      return {
        loading: false,
        countryInfo: action.payload,
      };
    case GET_ALL_COUNTRY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_COUNTRY_RESET:
      return {
        countryInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetUserByIDReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_REQUEST:
      return {
        loading: true,
      };
    case GET_USER_SUCCESS:
      return {
        loading: false,
        userById: action.payload,
      };
    case GET_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_USER_RESET:
      return {
        userById: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetLoggedInUserReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_LOGGED_IN_USER_REQUEST:
      return {
        loading: true,
      };
    case GET_LOGGED_IN_USER_SUCCESS:
      return {
        loading: false,
        loggedInUserInfo: action.payload,
      };
    case GET_LOGGED_IN_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_LOGGED_IN_USER_RESET:
      return {
        loggedInUserInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const CreateUserReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return {
        loading: true,
      };
    case CREATE_USER_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };
    case CREATE_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_USER_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAllUsersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_USERS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_USERS_SUCCESS:
      return {
        loading: false,
        userInfo: action.payload,
      };
    case GET_ALL_USERS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_USERS_RESET:
      return {
        userInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const DeleteUserReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_USER_REQUEST:
      return {
        loading: true,
      };
    case DELETE_USER_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case DELETE_USER_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case DELETE_USER_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const UpdateUserReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_USER_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_USER_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_USER_FAIL:
      return {
        laoding: false,
        updateUserError: action.payload,
      };
    case UPDATE_USER_RESET:
      return {
        ...state,
        success: false,
        message: null,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const ResetUserPasswordReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case RESET_PASSWORD_REQUEST:
      return {
        loading: true,
      };
    case RESET_PASSWORD_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case RESET_PASSWORD_FAIL:
      return {
        laoding: false,
        resetPasswordError: action.payload,
      };
    case RESET_PASSWORD_RESET:
      return {
        ...state,
        success: false,
        message: null,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const ChangeUserPasswordReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return {
        loading: true,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        laoding: false,
        changePasswordError: action.payload,
      };
    case CHANGE_PASSWORD_RESET:
      return {
        ...state,
        success: false,
        message: null,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetManageBookingDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_MANAGE_BOOKING_DATA_REQUEST:
      return {
        loading: true,
      };
    case GET_MANAGE_BOOKING_DATA_SUCCESS:
      return {
        loading: false,
        itineraryInfo: action.payload,
      };
    case GET_MANAGE_BOOKING_DATA_FAIL:
      return {
        loading: false,
        error: action?.payload?.response?.data,
      };
    case GET_MANAGE_BOOKING_DATA_RESET:
      return {};
    default:
      return state;
  }
};

export const PrintItineraryDataReducer = (state = {}, action) => {
  switch (action.type) {
    case PRINT_ITINERARY_DATA_REQUEST:
      return {
        printItineraryLoading: true,
      };
    case PRINT_ITINERARY_DATA_SUCCESS:
      return {
        printItineraryLoading: false,
        printItineraryInfo: action.payload,
      };
    case PRINT_ITINERARY_DATA_FAIL:
      return {
        printItineraryLoading: false,
        printItineraryError: action.payload,
      };
    case PRINT_ITINERARY_DATA_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const EmailItineraryDataReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_ITINERARY_DATA_REQUEST:
      return {
        emailItineraryLoading: true,
      };
    case EMAIL_ITINERARY_DATA_SUCCESS:
      return {
        emailItineraryLoading: false,
        emailItineraryInfo: action.payload,
      };
    case EMAIL_ITINERARY_DATA_FAIL:
      return {
        emailItineraryLoading: false,
        emailItineraryError: action.payload,
      };
    case EMAIL_ITINERARY_DATA_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetProductsDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PRODUCTS_REQUEST:
      return {
        loading: true,
      };
    case GET_PRODUCTS_SUCCESS:
      return {
        loading: false,
        productInfo: action.payload,
      };
    case GET_PRODUCTS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_PRODUCTS_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetUserPermissionDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_USER_PERMISSION_REQUEST:
      return {
        loading: true,
      };
    case GET_USER_PERMISSION_SUCCESS:
      return {
        loading: false,
        userPermissionInfo: action.payload,
      };
    case GET_USER_PERMISSION_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_USER_PERMISSION_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const CheckPCCReducer = (state = {}, action) => {
  switch (action.type) {
    case CHECK_PCC_REQUEST:
      return {
        loading: true,
      };
    case CHECK_PCC_SUCCESS:
      return {
        loading: false,
        pcc_check: action.payload,
      };
    case CHECK_PCC_FAIL:
      return {
        loading: false,
        error: action?.payload?.response?.data,
      };
    case CHECK_PCC_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetTicketReportDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TICKET_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_TICKET_REPORT_SUCCESS:
      return {
        loading: false,
        ticketReportData: action.payload,
      };
    case GET_TICKET_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_TICKET_REPORT_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetTpBatchReportDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_TP_BATCH_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_TP_BATCH_REPORT_SUCCESS:
      return {
        loading: false,
        tpBatchReportData: action.payload,
      };
    case GET_TP_BATCH_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_TP_BATCH_REPORT_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const EmailMultiPccTicketReportReducer = (state = {}, action) => {
  switch (action.type) {
    case EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST:
      return {
        loading: true,
      };
    case EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS:
      return {
        loading: false,
        emailReportInfo: action.payload,
      };
    case EMAIL_MULTI_PCC_TICKET_REPORT_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case EMAIL_MULTI_PCC_TICKET_REPORT_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetCurrencyReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CURRENCY_REQUEST:
      return {
        loading: true,
      };
    case GET_CURRENCY_SUCCESS:
      return {
        loading: false,
        currencyInfo: action.payload,
      };
    case GET_CURRENCY_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_CURRENCY_RESET:
      return {
        currencyInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const DownloadExcelFileReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_EXCEL_REQUEST:
      return {
        downloadExcelLoading: true,
      };
    case DOWNLOAD_EXCEL_SUCCESS:
      return {
        downloadExcelLoading: false,
        excelFile: action.payload,
      };
    case DOWNLOAD_EXCEL_FAIL:
      return {
        downloadExcelLoading: false,
        downloadExcelError: action.payload,
      };
    case DOWNLOAD_EXCEL_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const InvoiceDisplayReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_INVOICE_REQUEST:
      return {
        invoiceLoading: true,
        invoiceError: null,
        invoiceData: null,
      };
    case DOWNLOAD_INVOICE_SUCCESS:
      return {
        invoiceLoading: false,
        invoiceData: action.payload,
        invoiceError: null,
      };
    case DOWNLOAD_INVOICE_FAIL:
      return {
        invoiceLoading: false,
        invoiceError: action.payload,
        invoiceData: null,
      };
    case DOWNLOAD_INVOICE_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
export const DownloadCSVFileReducer = (state = {}, action) => {
  switch (action.type) {
    case DOWNLOAD_CSV_REQUEST:
      return {
        downloadCSVLoading: true,
      };
    case DOWNLOAD_CSV_SUCCESS:
      return {
        downloadCSVLoading: false,
        CSVFile: action.payload,
      };
    case DOWNLOAD_CSV_FAIL:
      return {
        downloadCSVLoading: false,
        downloadCSVError: action.payload,
      };
    case DOWNLOAD_CSV_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const CreateCustomerLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_CUSTOMER_LOGIN_REQUEST:
      return {
        loading: true,
      };
    case CREATE_CUSTOMER_LOGIN_SUCCESS:
      return {
        loading: false,
        customerLoginInfo: action.payload,
      };
    case CREATE_CUSTOMER_LOGIN_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case CREATE_CUSTOMER_LOGIN_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetAllCustomerLoginsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_CUSTOMERS_LOGINS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_CUSTOMERS_LOGINS_SUCCESS:
      return {
        loading: false,
        customerLoginsInfo: action.payload,
      };
    case GET_ALL_CUSTOMERS_LOGINS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_CUSTOMERS_LOGINS_RESET:
      return {
        customerLoginsInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const UpdateCustomerLoginsReducer = (
  state = { loading: false, success: false, message: {} },
  action
) => {
  switch (action.type) {
    case UPDATE_CUSTOMER_LOGINS_REQUEST:
      return {
        loading: true,
      };
    case UPDATE_CUSTOMER_LOGINS_SUCCESS:
      return {
        loading: false,
        success: true,
        message: action.payload,
      };
    case UPDATE_CUSTOMER_LOGINS_FAIL:
      return {
        laoding: false,
        updateerror: action.payload,
      };
    case UPDATE_CUSTOMER_LOGINS_RESET:
      return {
        ...state,
        success: false,
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const GetParentCustomersReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ALL_PARENT_CUSTOMERS_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_PARENT_CUSTOMERS_SUCCESS:
      return {
        loading: false,
        parentCustomersInfo: action.payload,
      };
    case GET_ALL_PARENT_CUSTOMERS_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case GET_ALL_PARENT_CUSTOMERS_RESET:
      return {
        parentCustomersInfo: {},
      };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const RemoveCustomerLogoReducer = (state = {}, action) => {
  switch (action.type) {
    case REMOVE_CUSTOMER_LOGO_REQUEST:
      return {
        loading: true,
      };
    case REMOVE_CUSTOMER_LOGO_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case REMOVE_CUSTOMER_LOGO_FAIL:
      return {
        loading: false,
        error: action.payload,
      };
    case REMOVE_CUSTOMER_LOGO_RESET:
      return {};
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};
